import { Component, OnInit, OnDestroy } from "@angular/core"
import { Store, Action } from "@ngrx/store"
import { RequestOptions } from "@angular/http";
import { Angular2TokenService } from "angular2-token";
import { AppState } from "@store/app-state"
import { Subscription } from "rxjs/Subscription";
import { RolesStore } from "@store/roles";
import { Role } from "@models/role";
import { User } from "@models/user";
import {
  FETCH_ROLE_USERS
} from "@reducers/roles";
import {
  UPDATE_USER,
  REPLACE_USER
} from "@reducers/user";
import { RemoteData, CompleterService, CompleterData, CompleterItem } from 'ng2-completer'
import { UserEffects } from "@reducers/effects/user";

@Component({
  selector: 'roles-view',
  templateUrl: './roles-view.pug',
})
export class RolesViewComponent implements OnInit, OnDestroy {

  private readonly emailUrl: string = "/api/v1/users/email_search?query="

  public roles: Role[]
  public roleUsers: User[]
  public activeRole: Role
  public selectedUser: User

  public emailSearchStr: string
  public emailCompleter: RemoteData

  public rolesSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private http: Angular2TokenService,
    private userEffects: UserEffects,
  ) {}

  ngOnInit() {
    this.rolesSubscription =
      this.store.select("rolesReducer").subscribe((s: RolesStore) => {
        this.roles = s.roles
        this.roleUsers = s.roleUsers
      })

    this.emailCompleter =
      this.completerService.remote(this.emailUrl, "email", "email")

    this.emailCompleter.requestOptions(
      new RequestOptions({
        headers: this.http.currentAuthHeaders,
      })
    )
  }

  clickedRole(role: Role) {
    this.activeRole = role
    this.store.dispatch({ type: FETCH_ROLE_USERS, payload: role.code })
  }

  clickedAddUser() {
    if (!this.selectedUser) { return }

    if (!this.selectedUser.roles.includes(this.activeRole.code)) {
      this.selectedUser.roles.push(this.activeRole.code)
      this.store.dispatch({ type: UPDATE_USER, payload: this.selectedUser })
      this.refreshRoleUsersAfterUpdate()
    }
  }

  clickedRemoveUserFromRole(user: User) {
    const payload     = User.clone(user)
    payload.roles   =
      payload.roles.filter((code: string) => code != this.activeRole.code)
    this.store.dispatch({ type: UPDATE_USER, payload })
    this.refreshRoleUsersAfterUpdate()
  }

  selectedUserToAdd(e: CompleterItem) {
    if (e && e.originalObject) {
      this.selectedUser = User.clone(e.originalObject)
    }
    else {
      this.selectedUser = null
    }
  }

  refreshRoleUsersAfterUpdate() {
    this.userEffects.update
      .filter((a: Action) => a.type == REPLACE_USER)
      .take(1)
      .subscribe(() => {
        this.store.dispatch({ type: FETCH_ROLE_USERS, payload: this.activeRole.code })
      })
  }

  ngOnDestroy() {
    this.rolesSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/roles-view.ts